import {
  GET_USER_MESSAGES,
  POST_USER_MESSAGE,
  DELETE_OR_PATCH_MESSAGE
} from "resources/ApiUrls"
import MyAxiosInstance from "utils/MyAxiosInstance"

const getAll = (userId) => MyAxiosInstance.get(GET_USER_MESSAGES(userId))

const create = (messageObj) => MyAxiosInstance.post(POST_USER_MESSAGE, messageObj)

const remove = (messageId) => MyAxiosInstance.delete(DELETE_OR_PATCH_MESSAGE(messageId))

const update = (messageId, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_PATCH_MESSAGE(messageId), fieldsToUpdate)

const messagesAPICalls = { getAll, create, remove, update }

export default messagesAPICalls